module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0665.3ee8b223.jpg";